import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { isMobile } from 'is-mobile';
import GuardedRoute from '../preorder/containers/GuardedRoute';
import useAuth from '../preorder/hooks/useAuth';
import Profile from './containers/Profile';
import { ProfileStoreProvider } from './contexts/profile';
import defautTheme from './defaultTheme';
import Coupon from './containers/coupon/Coupon';
import { CouponStoreProvider } from './contexts/coupon';
import RedeemCode from './containers/RedeemCode';
import { RedeemInfoStoreProvider } from './contexts/redeemCode';

export default () => {
  const [checkAuthenticated] = useAuth();
  const theme = createMuiTheme(defautTheme);

  return (
    <ThemeProvider theme={theme}>
      <ProfileStoreProvider>
        <CouponStoreProvider>
          <RedeemInfoStoreProvider>
            <div className="fz-container fz-m-auto">
              <Switch>
                <GuardedRoute
                  exact
                  path="/user/profile"
                  checkAuthenticated={checkAuthenticated}
                  component={Profile}
                  redirectPath={isMobile() ? '/auth/line/login' : '/register'}
                />
                <GuardedRoute
                  exact
                  path="/user/coupon"
                  checkAuthenticated={checkAuthenticated}
                  component={Coupon}
                  redirectPath={isMobile() ? '/auth/line/login' : '/register'}
                />
                <GuardedRoute
                  exact
                  path="/user/redeemCode"
                  checkAuthenticated={checkAuthenticated}
                  component={RedeemCode}
                  redirectPath={isMobile() ? '/auth/line/login' : '/register'}
                />
                <Redirect to="/user/profile" />
              </Switch>
            </div>
          </RedeemInfoStoreProvider>
        </CouponStoreProvider>
      </ProfileStoreProvider>
    </ThemeProvider>
  );
};
